import { createSlice } from "@reduxjs/toolkit";

const readWishlist = () => {
  try {
    return JSON.parse(localStorage.getItem("wishlist")) || [];
  } catch {
    return [];
  }
};

const persistWishlist = (items) => {
  localStorage.setItem("wishlist", JSON.stringify(items));
};

const initialState = {
  items: readWishlist(),
  totalCount: null, // server-side total (all types)
};

const wishlistSlice = createSlice({
  name: "wishlist",
  initialState,
  reducers: {
    addWishlistItem: (state, action) => {
      const exists = state.items.some(
        (item) =>
          String(item.id) === String(action.payload.id) &&
          item.type === action.payload.type
      );
      if (!exists) {
        state.items.push(action.payload);
        persistWishlist(state.items);
        // Increment count; if null, initialise from items length
        state.totalCount = state.totalCount !== null ? state.totalCount + 1 : state.items.length;
      }
    },
    toggleWishlistItem: (state, action) => {
      const existing = state.items.find(
        (item) =>
          String(item.id) === String(action.payload.id) &&
          item.type === action.payload.type
      );

      if (existing) {
        state.items = state.items.filter(
          (item) =>
            !(String(item.id) === String(action.payload.id) && item.type === action.payload.type)
        );
        state.totalCount = state.totalCount !== null
          ? Math.max(0, state.totalCount - 1)
          : state.items.length;
      } else {
        state.items.push(action.payload);
        state.totalCount = state.totalCount !== null ? state.totalCount + 1 : state.items.length;
      }

      persistWishlist(state.items);
    },
    removeWishlistItem: (state, action) => {
      // Accepts { id, type } for type-precise removal, or just id for backward compat
      const id = action.payload?.id ?? action.payload;
      const type = action.payload?.type;
      if (type) {
        state.items = state.items.filter(
          (item) => !(String(item.id) === String(id) && item.type === type)
        );
      } else {
        state.items = state.items.filter((item) => String(item.id) !== String(id));
      }
      // Decrement count; if null was never set, derive from updated items length
      state.totalCount = state.totalCount !== null
        ? Math.max(0, state.totalCount - 1)
        : state.items.length;
      persistWishlist(state.items);
    },

    clearWishlist: (state) => {
      state.items = [];
      state.totalCount = 0;
      localStorage.removeItem("wishlist");
    },
    setWishlistItems: (state, action) => {
      state.items = action.payload;
      persistWishlist(state.items);
    },
    setWishlistTotalCount: (state, action) => {
      state.totalCount = action.payload;
    },
  },
});

export const { addWishlistItem, toggleWishlistItem, removeWishlistItem, clearWishlist, setWishlistItems, setWishlistTotalCount } = wishlistSlice.actions;


export default wishlistSlice.reducer;
